'use client';

import { c as _c } from "react/compiler-runtime";
import { FactiiiRequirement, type PinnedFactiii } from '@shared/all/domains/factiiis';
import useFactiiis from '@shared/utils/hooks/useFactiiis';
import useLocalPreference from '@shared/utils/hooks/useLocalPreference';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { client } from '../../../utils/trpc';
import GoalModal from '../../factiiis/GoalModal';
import NewPost from '../NewPost';
import { ActiveFiltersDisplay, FactiiiFilterButton, FactiiiFilterDropdown } from './filters';
type Props = {
  pinnedFactiii?: PinnedFactiii;
  disableNewPost?: boolean;
  spaceSlug?: string;
};
const PostRenderOptions = t0 => {
  const $ = _c(33);
  const {
    pinnedFactiii,
    disableNewPost,
    spaceSlug
  } = t0;
  const {
    localPreferenceState
  } = useLocalPreference();
  const {
    getFactiiiIds
  } = useFactiiis(client);
  const [goalModalOpen, setGoalModalOpen] = useState(false);
  const [factiiiFilterOpen, setFactiiiFilterOpen] = useState(false);
  let t1;
  if ($[0] !== localPreferenceState.selectedFactiiis) {
    t1 = ["selected-factiiis", localPreferenceState.selectedFactiiis];
    $[0] = localPreferenceState.selectedFactiiis;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== getFactiiiIds || $[3] !== localPreferenceState.selectedFactiiis) {
    t2 = () => getFactiiiIds(localPreferenceState.selectedFactiiis);
    $[2] = getFactiiiIds;
    $[3] = localPreferenceState.selectedFactiiis;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = localPreferenceState.selectedFactiiis.length > 0;
  let t4;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      enabled: t3
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    data: selectedFactiiis
  } = useQuery(t4);
  let t5;
  if ($[9] !== pinnedFactiii?.requirements || $[10] !== selectedFactiiis) {
    t5 = (pinnedFactiii?.requirements?.includes(FactiiiRequirement.MEDIA_MATCH) ?? false) || (selectedFactiiis?.some(_temp) ?? false);
    $[9] = pinnedFactiii?.requirements;
    $[10] = selectedFactiiis;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const showMediaSearch = t5;
  let t6;
  if ($[12] !== factiiiFilterOpen) {
    t6 = <FactiiiFilterButton factiiiFilterOpen={factiiiFilterOpen} setFactiiiFilterOpen={setFactiiiFilterOpen} />;
    $[12] = factiiiFilterOpen;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== disableNewPost || $[15] !== pinnedFactiii || $[16] !== spaceSlug || $[17] !== t6) {
    t7 = <NewPost pinnedFactiii={pinnedFactiii} disableNewPost={disableNewPost} spaceSlug={spaceSlug} rightAction={t6} />;
    $[14] = disableNewPost;
    $[15] = pinnedFactiii;
    $[16] = spaceSlug;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== goalModalOpen) {
    t8 = goalModalOpen && <GoalModal closeHandler={() => setGoalModalOpen(false)} />;
    $[19] = goalModalOpen;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== factiiiFilterOpen || $[22] !== selectedFactiiis) {
    t9 = !factiiiFilterOpen && <ActiveFiltersDisplay selectedFactiiis={selectedFactiiis} />;
    $[21] = factiiiFilterOpen;
    $[22] = selectedFactiiis;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setGoalModalOpen(true);
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== factiiiFilterOpen || $[26] !== showMediaSearch) {
    t11 = <div className="relative"><FactiiiFilterDropdown factiiiFilterOpen={factiiiFilterOpen} setFactiiiFilterOpen={setFactiiiFilterOpen} onManageGoals={t10} showMediaSearch={showMediaSearch} /></div>;
    $[25] = factiiiFilterOpen;
    $[26] = showMediaSearch;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11 || $[29] !== t7 || $[30] !== t8 || $[31] !== t9) {
    t12 = <div className="mb-4 rounded-xl">{t7}{t8}{t9}{t11}</div>;
    $[28] = t11;
    $[29] = t7;
    $[30] = t8;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default PostRenderOptions;
function _temp(f) {
  return f.requirements?.includes(FactiiiRequirement.MEDIA_MATCH);
}